import React, { useState, useEffect, useRef, useCallback } from "react"; //Import useRef
import { FaBars, FaChevronDown, FaChevronUp, FaShoppingCart, FaStore, FaGlobe, FaBoxes, FaCog, FaTicketAlt, FaStar, FaRegStar, FaChartBar, FaUsers, FaPaintBrush, FaShoePrints, FaPlus, FaSignOutAlt, FaUserCircle, FaQrcode, FaShieldAlt, FaCashRegister, FaDesktop, FaShoppingBag, FaShoppingBasket, FaRulerCombined, FaBrain, FaHistory, FaClipboardCheck, FaLink, FaUndoAlt, FaExclamationTriangle, FaBell, FaPaperPlane, FaTruck, FaRocket, FaFileInvoice, FaFileExcel, FaSlidersH, FaBolt, FaWallet, FaCalendarAlt, FaMapMarkedAlt, FaLightbulb, FaFilm, FaNetworkWired, FaChartPie, FaBan, FaPlug, FaSync, FaClipboardList, FaGift } from "react-icons/fa";
import { MdViewModule } from "react-icons/md"; // Added for template manager icon
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CgProfile } from "react-icons/cg"; // Kept for existing profile logic
import { HiHome } from "react-icons/hi2";
import { BsBoxSeamFill } from "react-icons/bs";
import { TbHomeHand } from "react-icons/tb";
import { BiSolidCategory, BiLinkAlt } from "react-icons/bi";
import { MdOutlineImageSearch } from "react-icons/md";
import HeaderOrderBadge, { useHeaderOrderCount } from "./Notifications/HeaderOrderBadge";
import HeaderExpiryBadge, { useHeaderExpiredProductCount } from "./Notifications/HeaderExpiryBadge";
import { adminFetchJson } from "../services/apiService";
const API_BASE_URL = `${process.env.REACT_APP_API_URL}/zuntly/admin`;


// Navigation array with icons
const navigation = [
    { name: "Dashboard", href: "/dashboard", icon: <HiHome size="1.30em" /> },
    { name: "Zuntly Brain", href: "/zuntly-brain", icon: <FaBrain size="1.25em" />, highlight: true }, // AI Business Assistant
    { name: "Zuntly AI", href: "/zuntly-ai", icon: <FaLightbulb size="1.25em" />, highlight: true, superAdminOnly: true },
    { name: "Cinematic Studio", href: "/zuntly-cinematic-studio", icon: <FaFilm size="1.25em" />, highlight: true, superAdminOnly: true },
    { name: "Zuntly GeoIQ", href: "/zuntly-geoiq", icon: <FaMapMarkedAlt size="1.25em" />, highlight: true, superAdminOnly: true },
    { name: "Products", href: "/products", icon: <BsBoxSeamFill size="1.20em" /> },
    { name: "Bulk Products", href: "/bulk-products", icon: <FaFileExcel size="1.20em" /> },
    { name: "Product Expiry", href: "/product-expiry", icon: <FaCalendarAlt size="1.20em" /> },
    { name: "Product Variants", href: "/product-variants", icon: <BiLinkAlt size="1.25em" /> }, // Product Variant Mapping
    { name: "Orders", href: "/orders", icon: <FaShoppingCart size="1.25em" /> },
    {
        name: "Omni Commerce",
        href: "#",
        icon: <FaNetworkWired size="1.25em" />,
        highlight: true,
        superAdminOnly: true,
        subItems: [
            { name: "Dashboard", href: "/omni-commerce", icon: <FaChartPie size="1.1em" /> },
            { name: "Omni Orders", href: "/omni-commerce/orders", icon: <FaShoppingCart size="1.1em" /> },
            { name: "Returns", href: "/omni-commerce/returns", icon: <FaUndoAlt size="1.1em" /> },
            { name: "Cancellations", href: "/omni-commerce/cancellations", icon: <FaBan size="1.1em" /> },
            { name: "Shipping", href: "/omni-commerce/shipping", icon: <FaTruck size="1.1em" /> },
            { name: "Channel Connections", href: "/omni-commerce/settings", icon: <FaPlug size="1.1em" /> },
            { name: "Sync Logs", href: "/omni-commerce/sync-logs", icon: <FaSync size="1.1em" /> },
            { name: "Analytics", href: "/omni-commerce/analytics", icon: <FaChartBar size="1.1em" /> },
            { name: "Audit Logs", href: "/omni-commerce/audit-logs", icon: <FaClipboardList size="1.1em" /> },
        ],
    },
    { name: "Create Order", href: "/create-custom-order", icon: <FaFileInvoice size="1.25em" /> },
    { name: "Delivery Controls", href: "/delivery-controls", icon: <FaTruck size="1.25em" /> },
    { name: "Shiprocket Settings", href: "/shiprocket-settings", icon: <FaRocket size="1.25em" /> },
    {
        name: "Post-Order",
        href: "#",
        icon: <FaExclamationTriangle size="1.25em" />,
        subItems: [
            { name: "Command Center", href: "/post-order", icon: <FaExclamationTriangle size="1.1em" /> },
            { name: "Returns & Refunds", href: "/return-management", icon: <FaUndoAlt size="1.1em" /> },
        ],
    },
    {
        name: "Notifications",
        href: "#",
        icon: <FaBell size="1.25em" />,
        subItems: [
            { name: "Push Notifications", href: "/notification-templates", icon: <FaBell size="1.1em" /> },
            { name: "Send Notifications", href: "/manual-notifications", icon: <FaPaperPlane size="1.1em" /> },
        ],
    },
    { name: "Branches", href: "/branches", icon: <FaStore size="1.25em" /> },
    { name: "Zuntly Marketplace", href: "/marketplace-settings", icon: <FaShoppingBag size="1.25em" />, highlight: true, superAdminOnly: true }, // B2B Marketplace (Super Admin)
    { name: "Domains", href: "/domains", icon: <FaGlobe size="1.25em" /> },
    { name: "GST", href: "/gst", icon: <FaChartBar size="1.25em" /> },
    {
        name: "Inventory",
        href: "#", // Dropdown parent
        icon: <FaBoxes size="1.25em" />,
        subItems: [
            { name: "Manage Stock", href: "/inventory", icon: <FaBoxes size="1.1em" /> },
            { name: "Stock Approvals", href: "/inventory-approvals", icon: <FaClipboardCheck size="1.1em" /> },
            { name: "Stock Logs", href: "/inventory-logs", icon: <FaHistory size="1.1em" /> },
        ],
    },
    { name: "Metrics", href: "/metrics", icon: <FaRulerCombined size="1.25em" /> },
    { name: "Coupons", href: "/coupons", icon: <FaTicketAlt size="1.25em" /> },
    {
        name: "POS Systems",
        href: "#", // Indicates it's a dropdown parent
        icon: <FaDesktop size="1.25em" />,
        subItems: [
            { name: "Merchant Billing", href: "/merchant-billing", icon: <FaCashRegister size="1.1em" /> },
            { name: "Walk-in Analytics", href: "/walk-in-analytics", icon: <FaChartBar size="1.1em" /> },
            { name: "Template Manager", href: "/template-manager", icon: <MdViewModule size="1.1em" /> },
            { name: "Customer Analytics", href: "/template-manager/customer-analytics", icon: <FaUsers size="1.1em" /> },
            { name: "POS Offers", href: "/template-manager/pos-offers", icon: <FaGift size="1.1em" /> },
        ],
    },
    {
        name: "Purchase Control",
        href: "#", // Indicates it's a dropdown parent
        icon: <FaShoppingBag size="1.25em" />,
        subItems: [
            { name: "Vendors", href: "/vendors", icon: <FaUsers size="1.1em" /> },
            { name: "Purchase Orders", href: "/purchase-orders", icon: <FaShoppingBasket size="1.1em" /> },
        ],
    },
    {
        name: "Design",
        href: "#", // Indicates it's a dropdown parent
        icon: <FaPaintBrush size="1.25em" />,
        subItems: [
            { name: "Home Customizations", href: "/homeCustomizations", icon: <TbHomeHand size="1.1em" /> },
            { name: "Add Ons", href: "/product-addons", icon: <FaPlus size="1.1em" /> },
            { name: "Timer Deals", href: "/timer-deals", icon: <FaTicketAlt size="1.1em" /> },
            { name: "Flash Deals", href: "/flash-deals", icon: <FaBolt size="1.1em" /> },
            { name: "Free Cash", href: "/free-cash", icon: <FaWallet size="1.1em" /> },
            { name: "Banners", href: "/banners", icon: <MdOutlineImageSearch size="1.1em" /> },
            { name: "Image Links", href: "/image-links", icon: <FaLink size="1.1em" /> },
            { name: "Footer", href: "/dynamicFooter", icon: <FaShoePrints size="1.1em" /> },
        ],
    },
    {
        name: "Services",
        href: "#", // Indicates it's a dropdown parent
        icon: <FaCog size="1.25em" />,
        subItems: [
            // { name: "Coupons", href: "/coupons", icon: <FaTicketAlt size="1.1em" /> }, // <-- removed from here
            { name: "Control Centre", href: "/control-centre", icon: <FaSlidersH size="1.1em" /> },
            { name: "Categories", href: "/categories", icon: <BiSolidCategory size="1.1em" /> },
            { name: "Ratings", href: "/ratingsAndReviews", icon: <FaStar size="1.1em" /> },
            { name: "Manual rating", href: "/manual-rating", icon: <FaRegStar size="1.1em" /> },
            { name: "Customer Intelligence", href: "/customers", icon: <FaUsers size="1.1em" /> },
            { name: "Admin Permissions", href: "/adminPermissions", icon: <FaShieldAlt size="1.1em" /> },
        ],
    },
];


function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const Header = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [currentPath, setCurrentPath] = useState(location.pathname);

    const [isSidebarOpen, setIsSidebarOpen] = useState(false); // This now controls mobile sidebar visibility

    const [, setIsCustomizationsOpen] = useState(false);
    const [, setIsClientsOpen] = useState(false);
    const [, setIsDesignOpen] = useState(false);

    const [, setActiveSubItem] = useState(location.pathname);
    const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
    const [branchesData, setBranchesData] = useState([]);
    const [enableFreeCash, setEnableFreeCash] = useState(false);
    const [loading, setLoading] = useState(true);
    
    // Order notification count for sidebar badge
    const { orderCount } = useHeaderOrderCount();
    // Expired product options count for Product Expiry sidebar badge
    const { expiredCount } = useHeaderExpiredProductCount();
    const [selectedBranchId, setSelectedBranchId] = useState(null);
    const dropdownRef = useRef(null);

    const [isSidebarHoverExpanded, setIsSidebarHoverExpanded] = useState(false);
    // const [isSidebarPinned, setIsSidebarPinned] = useState(false); // Still commented out for hover-only focus
    const [openVerticalSubmenus, setOpenVerticalSubmenus] = useState({});

    const userData = JSON.parse(localStorage.getItem("userData"));
    const role = userData?.role;
    const supportAdminAccess = userData?.supportAdminAccess;
    // Admin (master + support) or Support Admin — both are role 2 with supportAdminAccess
    const isAdminOrSupportAdmin = role === 2 && supportAdminAccess === true;
    // Super Admin can also open these (API middleware already allows role 1)
    const canAccessPosLoyaltyTools = role === 1 || isAdminOrSupportAdmin;

    const updateSelectedBranch = useCallback(
        async (branchId) => {
            try {
                const { data } = await adminFetchJson('/clients/updateSelctedBranch', {
                    method: 'POST',
                    body: { _id: branchId },
                });
                if (data.success) {
                    const storedUserData = JSON.parse(localStorage.getItem("userData"));
                    const updatedUserData = { ...storedUserData, selectedBranch: branchId };
                    localStorage.setItem("userData", JSON.stringify(updatedUserData));
                    setSelectedBranchId(branchId);
                    navigate("/dashboard");
                    window.location.reload();
                }
            } catch (error) {
                console.error("Error updating selected branch:", error);
            }
        },
        [navigate]
    );

    const fetchBranches = useCallback(async () => {
        setLoading(true);
        try {
            const storedUserData = JSON.parse(localStorage.getItem("userData"));
            let data = null;

            // Use different endpoints based on role
            if (role === 1) {
                // Role 1 (Super Admin): fetch all branches
                ({ data } = await adminFetchJson('/clients/getBranchNames', {
                    method: 'POST',
                    body: {},
                }));
            } else if (role === 2) {
                // Role 2 (Admin): fetch accessible branches using getBranchNamesForUser
                ({ data } = await adminFetchJson('/clients/getBranchNamesForUser', {
                    method: 'POST',
                    body: {},
                }));
            }

            if (!data) return;

            if (data.success) {
                setBranchesData(data.data);

                if (role === 1) {
                    const storedBranchId = storedUserData?.selectedBranch;
                    const selectedMaster = data.data.find(
                        (b) => b.masterAccount && b.masterId === storedBranchId
                    );
                    setEnableFreeCash(!!selectedMaster?.enableFreeCash);
                } else if (role === 2) {
                    setEnableFreeCash(!!data.enableFreeCash);
                }
                
                if (role === 1) {
                    // For role 1, handle branch selection
                    const storedBranchId = storedUserData?.selectedBranch;
                    const activeBranches = data.data.filter(b => b.isActive !== false);
                    // Keep stored selection even if that master is inactive (super admin can view inactive masters)
                    if (storedBranchId && data.data.some(b => b.masterId === storedBranchId)) {
                        setSelectedBranchId(storedBranchId);
                    } else if (activeBranches.length > 0) {
                        // No valid stored branch at all — default to first active master
                        const defaultBranchId = activeBranches[0].masterId;
                        if (storedBranchId !== defaultBranchId) {
                            await updateSelectedBranch(defaultBranchId);
                        } else {
                            setSelectedBranchId(defaultBranchId);
                        }
                    }
                } else if (role === 2) {
                    // For role 2, set their own branch as selected
                    setSelectedBranchId(storedUserData?._id);
                }
            }
        } catch (error) {
            console.error("Error fetching branches:", error);
        } finally {
            setLoading(false);
        }
    }, [role, updateSelectedBranch]);


    const adjustedNavigation = navigation.map((item) => {
        if (item.name === "Inventory") {
            const filteredSubItems = item.subItems.filter((subItem) => {
                // Hide Stock Logs for role 2 users without support admin access
                if (role === 2 && !supportAdminAccess && subItem.name === "Stock Logs") return false;
                return true;
            });
            return { ...item, subItems: filteredSubItems };
        }

        if (item.name === "Services" || item.name === "Design" || item.name === "POS Systems" || item.name === "Purchase Control" || item.name === "Post-Order" || item.name === "Notifications") {
            const filteredSubItems = item.subItems.filter((subItem) => {
                if (subItem.name === "Free Cash" && !enableFreeCash) return false;
                // Customer Analytics + POS Offers: Admin / Support Admin only (and Super Admin)
                if ((subItem.name === "Customer Analytics" || subItem.name === "POS Offers")
                    && !canAccessPosLoyaltyTools) {
                    return false;
                }
                if (role === 2 && !supportAdminAccess && (subItem.name === "Home Customizations"
                    || subItem.name === "Coupons" || subItem.name === "Footer" || subItem.name === "Customer Intelligence"
                    || subItem.name === "Analytics" || subItem.name === "Banners" || subItem.name === "Categories"
                    || subItem.name === "Control Centre"
                    || subItem.name === "Walk-in Analytics" || subItem.name === "Template Manager" || subItem.name === "Command Center"
                    || subItem.name === "Push Notifications" || subItem.name === "Send Notifications"
                    || subItem.name === "Manual rating")) return false;
                if (role !== 1 && subItem.name === "Admin Permissions") return false;
                return true;
            });
            return { ...item, subItems: filteredSubItems };
        }
        return item;
    });

    const filteredNavigation = adjustedNavigation.filter((item) => {
        const restrictedRole2 = role === 2 && !supportAdminAccess;

        // Zuntly Marketplace — Super Admin (role 1) only
        if (item.superAdminOnly && role !== 1) return false;
        // Hide Zuntly Brain for role 2 users without support admin access
        if (item.name === "Zuntly Brain" && restrictedRole2) return false;
        // Restricted branch admins — hide order/delivery/design tools from sidebar
        if (restrictedRole2 && (
            item.name === "Create Order"
            || item.name === "Delivery Controls"
            || item.name === "Shiprocket Settings"
            || item.name === "Design"
        )) return false;
        if ((item.name === "Domains") && role === 2) return false;
        if (role === 1 && branchesData.length === 0 && item.name !== "Domains" && item.name !== "Branches" && item.name !== "Zuntly Marketplace") return false;
        if (item.name === "Branches") {
            if (role === 2) return supportAdminAccess;
            return true;
        }
        // Hide POS Systems if selected branch doesn't have enablePOS
        if (item.name === "POS Systems") {
            // For role 1: selectedBranchId is the masterId of the selected branch
            // For role 2: use their own userData._id
            let selectedBranch;
            if (role === 1) {
                // Find the branch where masterId matches selectedBranchId
                selectedBranch = branchesData.find(b => b.masterId === selectedBranchId);
            } else if (role === 2) {
                const storedUserData = JSON.parse(localStorage.getItem("userData"));
                // For role 2, find branch by their _id
                selectedBranch = branchesData.find(b => b._id === storedUserData?._id);
            }
            // Show POS Systems only if branch has enablePOS flag set to true
            if (!selectedBranch || selectedBranch.enablePOS !== true) return false;
            return true;
        }
        // Hide Purchase Control
        if (item.name === "Purchase Control") {
            if (role === 2) return supportAdminAccess;
            return true;
        }
        // Hide Metrics, GST, and Coupons same like Branches tab
        if (item.name === "Metrics" || item.name === "GST" || item.name === "Coupons" || item.name === "Product Variants") {
            if (role === 2) return supportAdminAccess;
            return true;
        }
        if (item.subItems && item.subItems.length === 0 && item.href === "#") return false;
        return true;
    });

    useEffect(() => {
        const storedUserData = JSON.parse(localStorage.getItem("userData"));
        setSelectedBranchId(storedUserData?.selectedBranch || null);
        if ((role === 1 || role === 2) && location.pathname !== "/createMasterBranch") {
            fetchBranches();
        } else {
            setLoading(false);
        }
        setCurrentPath(location.pathname);
        setActiveSubItem(location.pathname);
        setIsCustomizationsOpen(false);
        setIsClientsOpen(false);
        setIsDesignOpen(false);
    }, [role, location.pathname, fetchBranches]);

    const handleLogout = async () => {
        // Call logout API to properly remove session from server
        try {
            const userData = JSON.parse(localStorage.getItem("userData"));
            const sessionId = localStorage.getItem("sessionId");
            
            if (userData?._id && sessionId) {
                await fetch(`${API_BASE_URL.replace('/admin', '')}/auth/logout`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        userId: userData._id,
                        sessionId: sessionId
                    }),
                });
            }
        } catch (error) {
            console.error("Error calling logout API:", error);
        }
        
        localStorage.clear();
        window.location.reload();
    };

    const handleVerticalNavItemClick = (item) => {
        if (item.subItems && item.subItems.length > 0) {
            setOpenVerticalSubmenus(prev => ({ [item.name]: !prev[item.name] }));
            if (item.href && item.href !== "#") {
                navigate(item.href);
                setCurrentPath(item.href);
                if (isSidebarOpen) setIsSidebarOpen(false);
            }
        } else {
            navigate(item.href);
            setCurrentPath(item.href);
            if (isSidebarOpen) setIsSidebarOpen(false);
        }
        if (!item.subItems) setActiveSubItem(item.href);
    };

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleSubItemClick = (href) => {
        setActiveSubItem(href);
        setCurrentPath(href);
        navigate(href);
        if (isSidebarOpen) setIsSidebarOpen(false);
    };

    const handleBranchSelectFromDropdown = (branch) => {
        updateSelectedBranch(branch.masterId);
        setIsProfileDropdownOpen(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsProfileDropdownOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);

    const isMobileView = () => typeof window !== 'undefined' && window.innerWidth < 768; // md breakpoint

    const showText = (isMobileView() && isSidebarOpen) || (!isMobileView() && isSidebarHoverExpanded);
    // const showText = (isMobileView() && isSidebarOpen) || (!isMobileView() && (isSidebarHoverExpanded || isSidebarPinned)); // If pinning is re-enabled

    return (
        <>
            {/* Hamburger button for mobile, rendered by Header itself */}
            <div className="fixed inset-x-0 top-0 flex justify-between items-center p-3 shadow-md bg-gray-50 text-gray-700 z-50 md:hidden">
                <button
                    onClick={toggleSidebar}
                    className="p-2 text-gray-600 hover:text-gray-800 relative"
                    aria-label="Open menu"
                >
                    <FaBars size={20} />
                    {/* Mobile order notification badge */}
                    {orderCount > 0 && (
                        <span className="absolute -top-1 -right-1 min-w-[16px] h-4 flex items-center justify-center bg-red-500 text-white text-[10px] font-bold rounded-full px-1 animate-pulse">
                            {orderCount > 99 ? '99+' : orderCount}
                        </span>
                    )}
                </button>
                <p className="text-lg font-semibold tracking-wide">{userData?.name || "User Name"}</p>
                <button
                    className="p-2 text-blue-600 hover:text-blue-700 text-2xl animate-pulse font-bold"
                    aria-label="User profile"
                >
                    Z
                </button>
            </div>

            {/* Mobile Sidebar Overlay (for when mobile sidebar is open) */}
            {isSidebarOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm z-[58] md:hidden" // z-index below sidebar
                    onClick={toggleSidebar}
                ></div>
            )}

            {/* Vertical Sidebar */}
            <div
                className={classNames(
                    "fixed top-0 left-0 h-screen flex flex-col",
                    "bg-white text-gray-800", // Light mode background and text
                    "shadow-lg z-[60]", // z-index highest for sidebar
                    "transition-transform duration-300 ease-in-out w-64 sm:w-72", // Mobile width
                    isSidebarOpen ? "translate-x-0" : "-translate-x-full",
                    "md:translate-x-0 md:transition-all md:duration-300 md:ease-in-out",
                    isSidebarHoverExpanded ? "md:w-64" : "md:w-20"
                )}
                onMouseEnter={() => { if (!isMobileView()) setIsSidebarHoverExpanded(true); }}
                onMouseLeave={() => { if (!isMobileView()) setIsSidebarHoverExpanded(false); }}
            >
                {/* Logo and Control Area */}
                <div className="flex items-center justify-between p-4 h-16 border-b border-gray-300">
                    <div className={classNames("flex items-center transition-all duration-200 ease-in-out", showText ? "opacity-100 delay-150" : "opacity-0 w-0 overflow-hidden")}>
                        <img src="/zuntly_logo_expanded.png" alt="Zuntly" className="h-8 mr-2" onError={(e) => e.currentTarget.style.display = 'none'} />
                        <h1 className="text-2xl font-bold text-blue-600">Zuntly</h1>
                    </div>
                    <div className={classNames("flex items-center justify-center w-full transition-opacity duration-200 ease-in-out", !showText && !isMobileView() ? "opacity-100" : "opacity-0 md:opacity-0 absolute")}>
                        <img src="/zuntly_icon.png" alt="Z" className="h-8 w-8" onError={(e) => e.currentTarget.outerHTML = '<span class="text-2xl font-bold text-blue-600">Z</span>'} />
                    </div>            
                </div>

                {/* Navigation Links */}
                <nav className="flex-grow overflow-y-auto overflow-x-hidden py-4 space-y-1 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-200">
                    {filteredNavigation.map((item) => {
                        const isParentEffectivelyActive = (item.href !== "#" && currentPath === item.href) || (item.subItems && item.subItems.some(sub => sub.href === currentPath));
                        return (
                            <div key={item.name} className="px-3 group relative">
                                <div
                                    className={classNames(
                                        "flex items-center justify-between w-full px-3 py-2.5 rounded-lg cursor-pointer relative",
                                        "hover:bg-blue-100 transition-colors duration-150",
                                        isParentEffectivelyActive
                                            ? "text-blue-500 font-semibold"
                                            : "text-gray-700 hover:text-gray-900"
                                    )}
                                    onClick={() => handleVerticalNavItemClick(item)}
                                >
                                    {isParentEffectivelyActive && (
                                        <div className="absolute left-0 top-1/2 -translate-y-1/2 h-8 w-1 bg-blue-500 rounded-tr-full rounded-br-full before:absolute before:inset-0 before:w-20 before:h-20 before:rounded-full"></div>
                                    )}
                                    <div className="flex items-center">
                                        <span className="shrink-0 w-7 h-7 flex items-center justify-center text-lg relative">
                                            {React.cloneElement(item.icon, {
                                                className: classNames(
                                                    isParentEffectivelyActive
                                                        ? "text-blue-500"
                                                        : "text-gray-500 group-hover:text-gray-800 transition-colors duration-150"
                                                )
                                            })}
                                            {/* Order notification badge */}
                                            {item.name === "Orders" && orderCount > 0 && (
                                                <HeaderOrderBadge count={orderCount} />
                                            )}
                                            {/* Expired products badge — icon only when sidebar text is hidden */}
                                            {item.name === "Product Expiry" && expiredCount > 0 && !showText && (
                                                <HeaderExpiryBadge count={expiredCount} />
                                            )}
                                        </span>
                                        <span className={classNames(
                                            "ml-3 transition-opacity duration-200 ease-in-out whitespace-nowrap",
                                            showText ? "opacity-100 delay-100" : "opacity-0 max-w-0 md:opacity-0 md:max-w-0 overflow-hidden"
                                        )}>
                                            {item.name}
                                            {/* Inline order count when expanded */}
                                            {item.name === "Orders" && orderCount > 0 && showText && (
                                                <span className="ml-2 inline-flex items-center justify-center min-w-[20px] h-5 bg-red-500 text-white text-xs font-bold rounded-full px-1.5">
                                                    {orderCount > 99 ? '99+' : orderCount}
                                                </span>
                                            )}
                                            {/* Inline expired count when sidebar is expanded */}
                                            {item.name === "Product Expiry" && expiredCount > 0 && showText && (
                                                <span
                                                    className="ml-2 inline-flex items-center justify-center min-w-[20px] h-5 bg-amber-500 text-white text-xs font-bold rounded-full px-1.5"
                                                    title={`${expiredCount} expired product option${expiredCount === 1 ? '' : 's'}`}
                                                >
                                                    {expiredCount > 99 ? '99+' : expiredCount}
                                                </span>
                                            )}
                                        </span>
                                    </div>
                                    {item.subItems && item.subItems.length > 0 && showText && (
                                        <span className="transition-transform duration-200">
                                            {openVerticalSubmenus[item.name] ? <FaChevronUp size="0.8em" /> : <FaChevronDown size="0.8em" />}
                                        </span>
                                    )}
                                </div>
                                {!showText && !isMobileView() && (
                                    <div className="absolute left-full top-1/2 -translate-y-1/2 ml-4 px-2.5 py-1.5 bg-gray-800 text-white text-xs rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-150 pointer-events-none z-[65] whitespace-nowrap flex items-center gap-2">
                                        {item.name}
                                        {/* Order count in tooltip when collapsed */}
                                        {item.name === "Orders" && orderCount > 0 && (
                                            <span className="inline-flex items-center justify-center min-w-[18px] h-[18px] bg-red-500 text-white text-[10px] font-bold rounded-full px-1">
                                                {orderCount > 99 ? '99+' : orderCount}
                                            </span>
                                        )}
                                        {/* Expired count in tooltip when collapsed */}
                                        {item.name === "Product Expiry" && expiredCount > 0 && (
                                            <span className="inline-flex items-center justify-center min-w-[18px] h-[18px] bg-amber-500 text-white text-[10px] font-bold rounded-full px-1">
                                                {expiredCount > 99 ? '99+' : expiredCount}
                                            </span>
                                        )}
                                    </div>
                                )}
                                {showText && item.subItems && item.subItems.length > 0 && openVerticalSubmenus[item.name] && (
                                    <div className="mt-1 pl-5 space-y-0.5 transition-all duration-300 ease-in-out">
                                        {item.subItems.map((subItem) => (
                                            <Link key={subItem.name} to={subItem.href}
                                                onClick={(e) => { e.stopPropagation(); handleSubItemClick(subItem.href); }}
                                                title={subItem.name}
                                                className={classNames(
                                                    "flex items-center w-full pl-3 pr-2 py-2 rounded-md group/sub transition-colors duration-150 relative",
                                                    "hover:bg-blue-100",
                                                    currentPath === subItem.href
                                                        ? "text-blue-500 font-medium"
                                                        : "text-gray-500 hover:text-gray-800"
                                                )}>
                                                {currentPath === subItem.href && (
                                                    <div className="absolute left-0 top-1/2 -translate-y-1/2 h-8 w-1 bg-blue-500 rounded-tr-full rounded-br-full before:absolute before:inset-0 before:w-20 before:h-20 before:rounded-full"></div>
                                                )}
                                                <span className="shrink-0 w-7 h-7 flex items-center justify-center text-base">
                                                    {subItem.icon ? React.cloneElement(subItem.icon, {
                                                        className: classNames(
                                                            currentPath === subItem.href
                                                                ? "text-blue-500"
                                                                : "text-gray-500 group-hover/sub:text-gray-800 transition-colors duration-150"
                                                        )}) : <span className="w-1.5 h-1.5 bg-current rounded-full mr-2"></span>}
                                                </span>
                                                <span className="ml-2 text-sm whitespace-nowrap">{subItem.name}</span>
                                            </Link>
                                        ))}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </nav>

                {/* Bottom Profile/Settings Section */}
                <div className="p-3 border-t border-gray-300 space-y-1">
                    <div className="relative group" ref={dropdownRef}>
                        <button type="button"
                            className={classNames("flex items-center w-full px-3 py-2.5 rounded-lg text-gray-600 hover:bg-gray-200 hover:text-gray-800 focus:outline-none transition-colors duration-150", !showText && !isMobileView() ? "justify-center" : "justify-between")}
                            id="user-menu-button-vertical" aria-expanded={isProfileDropdownOpen} aria-haspopup="true" onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)} >
                            <div className="flex items-center">
                                <span className="shrink-0 w-7 h-7 flex items-center justify-center">
                                    <FaUserCircle className="text-gray-500 group-hover:text-gray-800 transition-colors duration-150" size="1.3em" />
                                </span>
                                {showText && (<span className="ml-3 text-sm truncate flex-1 text-left whitespace-nowrap">{userData?.name || "Profile"}</span>)}
                            </div>
                            {showText && (<FaChevronUp className={`transition-transform duration-200 ${isProfileDropdownOpen ? 'rotate-180' : ''}`} size="0.8em" />)}
                        </button>
                        {isProfileDropdownOpen && (
                            <div className="origin-bottom-left absolute bottom-full mb-2 rounded-xl shadow-2xl bg-white ring-1 ring-black ring-opacity-5 focus:outline-none transition-all duration-200 ease-out overflow-hidden z-[70] left-0 w-full min-w-[280px]">
                                {loading && ( <div className="absolute inset-0 flex items-center justify-center bg-white/50 dark:bg-gray-800/50 z-50"> <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div> </div> )}
                                <div className="p-2 space-y-2">
                                    <div className="text-md font-semibold text-center text-gray-800 px-3 py-2.5 border-b border-gray-200 flex items-center justify-center">
                                        <span>{userData?.name || "User Name"}</span>
                                        <FaQrcode 
                                            className="ml-2 text-gray-500 hover:text-blue-500 cursor-pointer" 
                                            size={20} 
                                            onClick={() => navigate('/qr-scanner')} 
                                            title="Scan QR Code"
                                        />
                                    </div>
                                    <Link to="/profile" onClick={() => { handleSubItemClick("/profile"); setIsProfileDropdownOpen(false); }} className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-blue-100 rounded-lg transition-colors" role="menuitem" >
                                        <CgProfile className="mr-3 text-lg text-blue-500 group-hover:text-blue-600" /> Profile
                                    </Link>
                                    {role === 1 && (
                                        <div className="border-t border-gray-200 pt-2">
                                            <div className="px-4 pb-1 text-xs font-semibold text-gray-500 uppercase tracking-wider">Masters</div>
                                            <div className="overflow-y-auto max-h-52 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 px-1 space-y-1">
                                                {branchesData.filter(branch => branch.masterAccount === true).length > 0 ? (
                                                    branchesData.filter(branch => branch.masterAccount === true).map((branch) => {
                                                        const isActive = branch.isActive !== false;
                                                        const isSelected = selectedBranchId === branch.masterId;
                                                        return (
                                                            <button
                                                                key={branch.masterId}
                                                                onClick={() => handleBranchSelectFromDropdown(branch)}
                                                                className={`w-full flex items-center justify-between px-4 py-3 text-sm text-left rounded-lg transition-colors
                                                                    ${isSelected ? "bg-blue-100 font-semibold text-blue-700" : ""}
                                                                    ${isActive ? "text-gray-700 hover:bg-blue-50" : "text-gray-500 hover:bg-red-50"}
                                                                    cursor-pointer
                                                                `}
                                                                role="menuitem"
                                                            >
                                                                <span className="flex items-center gap-2 truncate">
                                                                    <span className={`w-2 h-2 rounded-full flex-shrink-0 ${isActive ? "bg-green-500" : "bg-red-400"}`}></span>
                                                                    <span className="truncate">{branch.branchName}</span>
                                                                </span>
                                                                <span className="flex items-center gap-1.5 flex-shrink-0 ml-2">
                                                                    {!isActive && (
                                                                        <span className="text-[10px] font-medium bg-red-100 text-red-500 px-1.5 py-0.5 rounded">Inactive</span>
                                                                    )}
                                                                    {isSelected && (
                                                                        <svg className="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" /></svg>
                                                                    )}
                                                                </span>
                                                            </button>
                                                        );
                                                    })
                                                ) : (<div className="px-4 py-3 text-xs text-gray-500">No masters</div>)}
                                            </div>
                                            <Link to="/createMasterBranch" onClick={() => { handleSubItemClick("/createMasterBranch"); setIsProfileDropdownOpen(false); }} className="flex items-center px-4 py-3 mt-2 text-sm font-medium text-blue-600 hover:bg-blue-100 rounded-lg transition-colors" role="menuitem" >
                                                <FaPlus className="mr-3 text-lg" /> Add Master Branch
                                            </Link>
                                        </div>
                                    )}
                                    <button onClick={handleLogout} className="w-full flex items-center px-4 py-3 text-sm text-red-500 hover:bg-red-100 transition-colors rounded-lg" role="menuitem" >
                                        <FaSignOutAlt className="mr-3 text-lg" /> Logout
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Header;